import { getAccentHexColor, getAccentTint } from "./accentPalette";

export function getAvatarHexColor(seed, fallback = "arawaks.campfireRed") {
  return getAccentHexColor(seed, fallback);
}

export function getAvatarTint(seed, strength = 12) {
  return getAccentTint(seed, strength);
}

export function resolveAvatarUrl(entity) {
  if (!entity || typeof entity !== "object") return undefined;

  const keys = [
    "avatarUrl",
    "fotoUrl",
    "photoUrl",
    "photoURL",
    "avatar",
    "imageUrl",
    "imagenUrl",
    "imagen",
    "foto",
    "picture",
    "pictureUrl",
    "downloadUrl",
  ];

  for (const key of keys) {
    const value = entity[key];
    if (typeof value === "string" && value.trim()) return value.trim();
  }

  return undefined;
}
